import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IconCheck, IconArrowLeft, IconArrowRight } from '@tabler/icons-react';
import { apiService } from '../services/api';
import '../components/LoginForm.css';

export const ForgotPasswordPage: React.FC = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(null);

        const response = await apiService.forgotPassword(email);

        if (response.success) {
            setSuccess(response.message || 'Ak účet s týmto emailom existuje, bol odoslaný email s odkazom na obnovenie hesla.');
        } else {
            setError(response.message || 'Nastala chyba. Skúste to znova neskôr.');
        }

        setLoading(false);
    };

    return (
        <div className="v5-login">
            <aside className="v5-login-hero">
                <div className="v5-hero-brand">
                    flowy<span className="v5-brand-dot">.</span>
                </div>

                <div className="v5-hero-body">
                    <h1 className="v5-hero-title">Zabudli ste heslo?</h1>
                    <p className="v5-hero-sub">
                        Netrápte sa — pošleme vám odkaz na jeho obnovu.
                    </p>
                    <ul className="v5-hero-features">
                        <li className="v5-hero-feat">
                            <span className="v5-hero-feat-mark"><IconCheck size={12} stroke={3}/></span>
                            Rýchle obnovenie cez email
                        </li>
                        <li className="v5-hero-feat">
                            <span className="v5-hero-feat-mark"><IconCheck size={12} stroke={3}/></span>
                            Odkaz platný 1 hodinu
                        </li>
                        <li className="v5-hero-feat">
                            <span className="v5-hero-feat-mark"><IconCheck size={12} stroke={3}/></span>
                            Vaše dáta sú v bezpečí
                        </li>
                    </ul>
                </div>

                <div className="v5-hero-footer">© Flowy, a.s. · Košice</div>
            </aside>

            <main className="v5-login-panel">
                <div className="v5-login-form-wrap">
                    <div className="v5-login-form-head">
                        <h1 className="v5-login-title">Obnovenie hesla</h1>
                        <p className="v5-login-subtitle">Zadajte email a pošleme vám odkaz na obnovu</p>
                    </div>

                    {error && <div className="v5-login-error">{error}</div>}
                    {success && <div className="v5-login-success">{success}</div>}

                    {!success && (
                        <form onSubmit={handleSubmit}>
                            <div className="v5-login-field">
                                <label htmlFor="email">Email</label>
                                <input
                                    id="email"
                                    type="email"
                                    className="form-control"
                                    placeholder="vas@email.sk"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    autoComplete="email"
                                    autoFocus
                                />
                            </div>

                            <button type="submit" className="v5-login-submit" disabled={loading} style={{marginTop: 6}}>
                                {loading ? 'Odosielam…' : (
                                    <>
                                        Odoslať odkaz
                                        <IconArrowRight size={18} className="v5-login-submit-arrow"/>
                                    </>
                                )}
                            </button>
                        </form>
                    )}

                    <div className="v5-login-footer" style={{marginTop: 20, display: 'inline-flex', alignItems: 'center', gap: 4, width: '100%', justifyContent: 'center'}}>
                        <Link to="/" style={{display: 'inline-flex', alignItems: 'center', gap: 4}}>
                            <IconArrowLeft size={14}/>
                            Späť na prihlásenie
                        </Link>
                    </div>
                </div>
            </main>
        </div>
    );
};
